<template>
    <v-dialog v-model="visible" max-width="880" overlay-opacity="0.82" content-class="promocional__dialogo" @click:outside="cerrar">
        <v-card v-if="video" color="#0e1326" dark class="promocional">
            <v-card-title class="text-subtitle-1 font-weight-bold py-2">
                <v-icon small color="secondary" class="mr-2">campaign</v-icon>
                {{ video.titulo }}
                <v-spacer></v-spacer>
                <v-btn icon small :title="silenciado ? 'Activar sonido' : 'Silenciar'" @click="alternarSonido">
                    <v-icon>{{ silenciado ? 'volume_off' : 'volume_up' }}</v-icon>
                </v-btn>
                <v-btn icon small title="Cerrar" @click="cerrar"><v-icon>close</v-icon></v-btn>
            </v-card-title>

            <!-- El reproductor solo existe mientras el diálogo está abierto: al cerrar deja de sonar. -->
            <reproductor-video
                v-if="visible"
                ref="reproductor"
                :video-url="video.video_url"
                :youtube-id="video.video_youtube_id"
                autoplay silenciado controles
                @inicio="registrar('inicio')"
                @fin="terminado"
                @silencio="silenciado = $event"
                @error="cerrar"
            />

            <v-card-actions class="px-4">
                <span class="text-caption" style="opacity: .7">Información de INFOP para usted.</span>
                <v-spacer></v-spacer>
                <v-btn small text @click="cerrar">Cerrar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
/**
 * Ventana emergente con el video promocional (cursos o academias) que el API
 * eligió para el participante según su programación y disparador. Es poco
 * invasiva: aparece una sola vez por visita, con un pequeño retraso, nunca
 * encima del slider ni de un video de felicitación, y se puede cerrar siempre.
 */
import ReproductorVideo from "./ReproductorVideo.vue";

const CLAVE_VISITA = "video_promocional_visita";

export default {
    name: "VideoPromocional",
    components: {ReproductorVideo},
    props: {
        video: {type: Object, default: null},
    },
    data() {
        return {
            visible: false,
            silenciado: true,
            sliderAbierto: false,
            felicitando: false,
            espera: null,
            alSlider: null,
            alFelicitar: null,
        };
    },
    watch: {
        video(valor) {
            if (valor) this.programar();
        },
    },
    methods: {
        programar() {
            clearTimeout(this.espera);
            this.espera = setTimeout(() => this.intentarAbrir(), 1200);
        },
        intentarAbrir() {
            if (!this.video || this.visible) return;
            // Se espera a que cierren el slider o termine la felicitación.
            if (this.sliderAbierto || this.felicitando) return;

            try {
                sessionStorage.setItem(CLAVE_VISITA, new Date().toISOString());
            } catch (e) { /* almacenamiento no disponible */ }

            this.silenciado = true;
            this.visible = true;
        },
        registrar(evento) {
            if (!this.video) return;
            window.axios.post("/videos/evento", {video_id: this.video.video_id, evento}).catch(() => {});
        },
        terminado() {
            this.registrar("fin");
            // Se deja la ventana para que la persona la cierre; el video ya no suena.
        },
        alternarSonido() {
            const reproductor = this.$refs.reproductor;
            if (!reproductor) return;
            const nuevo = !reproductor.estaSilenciado();
            reproductor.silenciar(nuevo);
            this.silenciado = nuevo;
        },
        cerrar() {
            this.visible = false;
            this.$emit("cerrado");
        },
    },
    created() {
        this.alSlider = (evento) => {
            this.sliderAbierto = evento.detail === "abierto";
            if (!this.sliderAbierto && this.video && !this.visible) this.programar();
        };
        this.alFelicitar = (evento) => {
            this.felicitando = evento.detail === "inicio";
            if (this.felicitando && this.visible) this.cerrar();
        };
        window.addEventListener("slider-popup", this.alSlider);
        window.addEventListener("video-felicitacion", this.alFelicitar);
        if (this.video) this.programar();
    },
    beforeDestroy() {
        clearTimeout(this.espera);
        window.removeEventListener("slider-popup", this.alSlider);
        window.removeEventListener("video-felicitacion", this.alFelicitar);
    },
}
</script>

<style lang="scss" scoped>
.promocional {
    overflow: hidden;
}
</style>
